import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import OffersIndex from "../../../components/SidetabPages/Offers/OffersIndex";

const Offers = () => {
  return (
    <>
      <AnnouncementBar />
      <OffersIndex />
    </>
  );
};
export default Offers;
